import { truncateName } from "@/api/helper";
import Badge from "@/components/core/badge";
import DataTable, { type ColumnDef } from "@/components/core/data-table";
import Pagination from "@/components/core/pagination";
import { Route } from "@/routes/_dashboard.occ-dashboard";
import { formatDate } from "@/utils/format-date";
import { useQuery, useSuspenseQuery } from "@tanstack/react-query";
import { Link, useNavigate } from "@tanstack/react-router";
import { caseActivityPaymentQueryOptions } from "../case-record/api/queries/case-activitiy-payment-query";

import { caseRecordsQueryOptions } from "@/features/case-record/api/queries/case-records-query";
import { formatNumber } from "@/utils/format-number";
import { useEffect } from "react";
import type { CaseRecord } from "../case-record/types/case-records";

export default function IncomingJdr() {
	const search = Route.useSearch();
	const navigate = useNavigate();

	const casesQuery = useSuspenseQuery(
		caseRecordsQueryOptions({
			status: "for_raffling",
			tabs: "for_jdr",
		}),
	);

	const meta = casesQuery.data.meta;
	const cases = casesQuery.data?.data;

	const columns: ColumnDef<CaseRecord>[] = [
		{
			id: "case_number",
			label: "Case Number",
			cellClassName: "min-w-[250px]",
			cell: ({ data, onClick }) => (
				<Link
					to={`/raffle/create/${data.id}`}
					className="font-semibold text-blue-600 hover:text-blue-500"
				>
					{truncateName(data.case_number, 30)}
				</Link>
			),
		},
		{
			id: "case_title",
			label: "Case Title",
			cellClassName: "min-w-[200px]",
			cell: ({ data }) => data.case_title,
		},
		{
			id: "branch",
			label: "Handling Court",
			cellClassName: "min-w-[200px]",
			cell: ({ data }) => data.branch,
		},
		{
			id: "created_at",
			label: "Date Filed",
			cellClassName: "min-w-[120px]",
			cell: ({ data }) => formatDate(data.created_at, "PPp"),
		},
	];

	return (
		<div className="flex flex-col w-full h-full rounded-md border border-border/50 overflow-hidden">
			<div className="flex flex-col w-full py-1 px-3">
				<DataTable
					className="border-collapse"
					data={cases}
					columns={columns}
					stickyHead={false}
					stickyCol={false}
					maxHeight={400}
					showBorder={false}
					compact={false}
				/>

				<Pagination
					onClick={async (page) => {
						await navigate({
							to: "/occ-dashboard",
							search: (old) => ({
								...old,
								page,
							}),
							replace: true,
						});
					}}
					initialPage={meta.current_page}
					pageCount={meta.last_page}
				/>
			</div>
		</div>
	);
}
